// Cálculos sobre los muestreos que devuelve GET /muestreos (ya filtrados por sucursal y fechas).
// Todo sale del desglose por familia de cada muestreo. Las diferencias nunca se suman con signo:
// un sobrante y un faltante son dos diferencias, no se compensan.
// Si se filtra por familia, sólo se cuenta esa familia dentro de cada muestreo.

const DIA_MS = 24 * 60 * 60 * 1000;

const familiasDe = (m, familia) => (m.familias || []).filter((f) => !familia || f.codigo === familia);

export const Estadisticas = {
  resumen: (muestreos, familia = null) => {
    const r = {
      muestreos: muestreos.length,
      procesados: 0,
      articulos: 0,
      articulosSobrante: 0,
      articulosFaltante: 0,
      articulosConDiferencia: 0,
      unidadesSobrante: 0,
      unidadesFaltante: 0,
      unidadesDiferencia: 0,
      familias: 0,
    };
    const codigos = new Set();
    for (const m of muestreos) {
      const fams = familiasDe(m, familia);
      if ((m.familias || []).length > 0) r.procesados++;
      for (const f of fams) {
        codigos.add(f.codigo);
        r.articulos += f.articulos;
        r.articulosSobrante += f.articulosSobrante;
        r.articulosFaltante += f.articulosFaltante;
        r.unidadesSobrante += f.unidadesSobrante;
        r.unidadesFaltante += f.unidadesFaltante;
      }
    }
    r.articulosConDiferencia = r.articulosSobrante + r.articulosFaltante;
    r.unidadesDiferencia = r.unidadesSobrante + r.unidadesFaltante;
    r.familias = codigos.size;
    return r;
  },

  // Una fila por familia: diferencias acumuladas y frecuencia de muestreo en el período.
  // fechaRef es contra qué fecha se calculan los "días desde el último" (el fin del período o hoy).
  porFamilia: (muestreos, familia = null, fechaRef = new Date()) => {
    const mapa = new Map();
    for (const m of muestreos) {
      const fecha = new Date(m.fechaCierre);
      for (const f of familiasDe(m, familia)) {
        let a = mapa.get(f.codigo);
        if (!a) {
          a = {
            codigo: f.codigo,
            nombre: f.nombre || "",
            muestreos: 0,
            articulos: 0,
            articulosSobrante: 0,
            articulosFaltante: 0,
            unidadesSobrante: 0,
            unidadesFaltante: 0,
            fechas: [],
          };
          mapa.set(f.codigo, a);
        }
        if (!a.nombre && f.nombre) a.nombre = f.nombre;
        a.muestreos++;
        a.articulos += f.articulos;
        a.articulosSobrante += f.articulosSobrante;
        a.articulosFaltante += f.articulosFaltante;
        a.unidadesSobrante += f.unidadesSobrante;
        a.unidadesFaltante += f.unidadesFaltante;
        if (!isNaN(fecha)) a.fechas.push(fecha);
      }
    }

    return [...mapa.values()]
      .map((a) => {
        const fechas = a.fechas.sort((x, y) => x - y);
        const { fechas: _, ...resto } = a;
        let promedioDias = null;
        if (fechas.length >= 2) {
          promedioDias = Math.round(((fechas[fechas.length - 1] - fechas[0]) / (fechas.length - 1) / DIA_MS) * 10) / 10;
        }
        const ultima = fechas.length ? fechas[fechas.length - 1] : null;
        return {
          ...resto,
          articulosConDiferencia: a.articulosSobrante + a.articulosFaltante,
          unidadesDiferencia: a.unidadesSobrante + a.unidadesFaltante,
          primera: fechas.length ? fechas[0] : null,
          ultima,
          promedioDias,
          diasDesdeUltimo: ultima ? Math.max(0, Math.round((fechaRef - ultima) / DIA_MS)) : null,
        };
      })
      .sort((x, y) => x.codigo.localeCompare(y.codigo));
  },
};
